import ContractAction from 'model/actions/contract';
import React from 'react';
import { useDispatch } from 'react-redux';
import bgPopup from 'assets/images/popup-loyalty/bg-popup.png';
import iconTop from 'assets/images/popup-loyalty/icon-top.png';
import iconBot from 'assets/images/popup-loyalty/icon-bot.png';
import x from 'assets/images/popup-loyalty/x.png';

export const PopupLoyalty = () => {
  const dispatch = useDispatch();
  return (
    <>
      <div
        className='fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm transition-opacity'
        onClick={() => dispatch(ContractAction.setPopupLoyalty(false))}
      >
        <div
          className='relative w-[90%] max-w-4xl overflow-visible rounded-[2rem] bg-white shadow-2xl'
          style={{
            backgroundImage: `url(${bgPopup})`,
            backgroundSize: '100% 100%',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            minHeight: '550px',
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <img
            className='absolute left-1/2 top-[-110px] z-10 w-[180px] -translate-x-1/2 md:top-[-120px] md:w-[200px]'
            src={iconTop}
          />
          <button
            onClick={() => dispatch(ContractAction.setPopupLoyalty(false))}
            className='absolute right-[-33px] top-[-67px] rounded-full p-2 text-gray-400 transition-colors focus:outline-none'
          >
            <img src={x} alt='close' className='w-[80px]' />
          </button>
          <div className='mt-[75px] flex h-[350px] flex-col overflow-auto px-10 md:mt-0 md:h-full md:overflow-hidden md:px-20 md:py-20'>
            <p className='mb-2  font-roboto-bold text-[15px] leading-relaxed md:text-left md:text-[17px]'>
              BaoViet Loyalty 2026: Trải nghiệm mới – Tri ân tới từng Khách hàng!
            </p>
            <p className='mb-2  text-[15px] leading-relaxed md:text-left md:text-[17px]'>
              Thay lời cảm ơn chân thành gửi đến Quý khách, Bảo Việt Nhân thọ xin thông báo những
              điểm mới giúp tối ưu hóa quyền lợi của Quý khách trong năm 2026:
            </p>

            <div className='mb-2 space-y-2  text-[15px] md:pl-[18px] md:text-[17px]'>
              <div>
                <span className='font-roboto-bold'>1. Nhận quà trực tiếp:</span> Từ tháng 8 đến hết
                tháng 10/2026, quà tặng tri ân sẽ được gửi đến tận tay Quý khách (thay cho việc tự
                thao tác đổi điểm trên MyBVLife).
              </div>
              <div>
                <span className='font-roboto-bold'>2. Điểm tích lũy năm 2026:</span> Toàn bộ điểm
                tích lũy năm 2026 của Quý khách sẽ tự động quy đổi thành quà tặng tương ứng với hạng
                của khách hàng. Hệ thống sẽ cập nhật lại điểm sau khi giao quà thành công.
              </div>
              <div>
                <span className='font-roboto-bold'>3. Điểm tích lũy năm 2025:</span> Điểm tích lũy
                năm 2025 (hạn dùng đến 31/12/2026) vẫn được áp dụng đổi quà trên MyBVLife. Danh mục
                quà tặng đang được hoàn thiện và sẽ ra mắt Quý khách trong thời gian sớm nhất.
              </div>
            </div>

            <p className=' text-[15px] md:text-[17px]'>
              Cảm ơn Quý khách đã luôn tin tưởng và đồng hành cùng Bảo Việt Nhân thọ!
            </p>
          </div>
          <img
            className='absolute bottom-[40px] left-1/2 w-[25px] -translate-x-1/2 md:w-[30px]'
            src={iconBot}
            alt='icon bottom'
          />
        </div>
      </div>
    </>
  );
};
